import EmailContent from '../../components/campaign-details/email';

function EmailDetail() {
  return <EmailContent />;
}

export default EmailDetail;
